<template>
  <div class="info-wrapper">
    <div class="header">
      <div class="header-left">
        <el-select class="select-input" v-model="typeValue" placeholder="类别" size="small" @change="imageTypeValueChange">
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select class="select-input" v-model="imageTypeValue" placeholder="影像模态" size="small"
                   @change="handleData">
          <el-option
            v-for="item in imageTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select class="select-input" v-model="roleValue" placeholder="团队/组/用户名称" size="small" @change="handleData">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="btn export-btn" @click="showStatisticExportDialog">导出</div>
      </div>
      <div class="header-right">
        <ul class="date--btn-box">
          <li class="date-btn" :class="{active: cycleType === '周'}" @click="selectCycle('周')">周</li>
          <li class="date-btn" :class="{active: cycleType === '月'}" @click="selectCycle('月')">月</li>
          <li class="date-btn" :class="{active: cycleType === '年'}" @click="selectCycle('年')">年</li>
        </ul>
        <el-date-picker
          style="margin-left: 10px;width: 47%"
          class="calendar"
          :class="{active: cycleType === 'date'}"
          v-model="date"
          size="small"
          @change="dateChange"
          type="daterange"
          value-format="yyyy-M-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <el-container style="position: absolute;left: 0;right: 0;top: 52px;bottom: 0;">
      <el-main class="main" style="margin: 0% 5%;
    background-color: #ebebeb;">
        <div class="wrapper">
          <div class="quick-view">
            <div class="head">
              <div class="title">快速浏览</div>
              <div
                class="period"
                v-show="top10TimeStart && (cycleType === '周' || cycleType === '月' || cycleType === '年')"
              >{{top10TimeStart}} 至 {{top10TimeEnd}}</div>
              <div class="period" v-show="dateStart && cycleType === 'date'">{{dateStart}} 至 {{dateEnd}}</div>
            </div>
            <ul class="content">
              <li class="item">
                <div class="left-content">
                  <div class="til">诊断总数</div>
                  <div class="info-box">
                    <div class="numbers">{{diagnosisSum}}</div>
                    <div class="floating" v-show="isShowDiagnoseFloatation">
                      <div class="floating-icon iconfont icon-up" v-show="diagnoseFloatation === 'up'">&#xe605;</div>
                      <div class="floating-icon iconfont icon-down" v-show="diagnoseFloatation === 'down'">&#xe604;
                      </div>
                      <div class="floating-icon iconfont icon-uniformity" v-show="diagnoseFloatation === 'uniformity'">
                        -
                      </div>
                      <div class="floating-num">{{diagnosisNum}}%</div>
                    </div>
                  </div>
                </div>
                <div class="iconfont icon icon-1">&#xe753;</div>
              </li>
              <li class="item">
                <div class="left-content">
                  <div class="til">患者总数</div>
                  <div class="info-box">
                    <div class="numbers">{{patientSum}}</div>
                    <div class="floating" v-show="isShowPatientFloatation">
                      <div class="floating-icon iconfont icon-up" v-show="patientFloatation === 'up'">&#xe605;</div>
                      <div class="floating-icon iconfont icon-down" v-show="patientFloatation === 'down'">&#xe604;</div>
                      <div class="floating-icon iconfont icon-uniformity" v-show="patientFloatation === 'uniformity'">
                        -
                      </div>
                      <div class="floating-num">{{patientNum}}%</div>
                    </div>
                  </div>
                </div>
                <div class="iconfont icon icon-2">&#xe611;</div>
              </li>
              <li class="item">
                <div class="left-content">
                  <div class="til">影像总数</div>
                  <div class="info-box">
                    <div class="numbers">{{imageSum}}</div>
                    <div class="floating" v-show="isShowImageFloatation">
                      <div class="floating-icon iconfont icon-up" v-show="imageFloatation === 'up'">&#xe605;</div>
                      <div class="floating-icon iconfont icon-down" v-show="imageFloatation === 'down'">&#xe604;
                      </div>
                      <div class="floating-icon iconfont icon-uniformity" v-show="imageFloatation === 'uniformity'">
                        -
                      </div>
                      <div class="floating-num">{{imageNum}}%</div>
                    </div>
                  </div>
                </div>
                <div class="iconfont icon icon-4">&#xe61e;</div>
              </li>
              <li class="item">
                <div class="left-content">
                  <div class="til">费用总计(RMB)</div>
                  <div class="info-box">
                    <div class="numbers">{{feeSum}}</div>
                    <div class="floating" v-show="isShowFeeFloatation">
                      <div class="floating-icon iconfont icon-up" v-show="feeFloatation === 'up'">&#xe605;</div>
                      <div class="floating-icon iconfont icon-down" v-show="feeFloatation === 'down'">&#xe604;</div>
                      <div class="floating-icon iconfont icon-uniformity" v-show="feeFloatation === 'uniformity'">-
                      </div>
                      <div class="floating-num">{{feeNum}}%</div>
                    </div>
                  </div>
                </div>
                <div class="iconfont icon icon-3">&#xe617;</div>
              </li>
            </ul>
          </div>
          <div class="details-info">
            <div class="head">
              <div class="title">详细总汇</div>
              <div
                class="period"
                v-show="top10TimeStart && (cycleType === '周' || cycleType === '月' || cycleType === '年')"
              >{{top10TimeStart}} 至 {{top10TimeEnd}}</div>
              <div class="period" v-show="dateStart && cycleType === 'date'">{{dateStart}} 至 {{dateEnd}}</div>
            </div>
            <ul class="line-content">
              <li class="item">
                <div class="til">诊断数量分布</div>
                <div class="line-info" ref="diagnoseChart">
                </div>
              </li>
              <li class="item">
                <div class="til">患者数量分布</div>
                <div class="line-info" ref="patientChart">
                </div>
              </li>
              <li class="item">
                <div class="til">影像数量分布</div>
                <div class="line-info" ref="imagesChart">
                </div>
              </li>
              <li class="item">
                <div class="til">费用分布</div>
                <div class="line-info" ref="costChart">
                </div>
              </li>
            </ul>
            <ul class="max-info" v-show="roleValue.split('_')[0] === '3'">
              <li class="item">
                <div class="til">诊断最多的一天</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{dayMaxDiagnosisDate}}</span>
                    <span class="week">{{dayMaxDiagnosisWeek}}</span>
                  </div>
                  <div class="number">{{dayMaxDiagnosisValue}}</div>
                </div>
              </li>
              <li class="item">
                <div class="til">患者最多的一天</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{dayMaxPatientDate}}</span>
                    <span class="week">{{dayMaxPatientWeek}}</span>
                  </div>
                  <div class="number">{{dayMaxPatientValue}}</div>
                </div>
              </li>
              <li class="item">
                <div class="til">影像最多的一天</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{dayMaxImageDate}}</span>
                    <span class="week">{{dayMaxImageWeek}}</span>
                  </div>
                  <div class="number">{{dayMaxImageValue}}</div>
                </div>
              </li>
              <li class="item">
                <div class="til">收费最多的一天</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{dayMaxFeeDate}}</span>
                    <span class="week">{{dayMaxFeeWeek}}</span>
                  </div>
                  <div class="number">{{dayMaxFeeValue}}</div>
                </div>
              </li>
            </ul>
            <ul class="max-info" v-show="roleValue.split('_')[0] === '1' || roleValue.split('_')[0] === '2'">
              <li class="item">
                <div class="til">诊断最多的医生</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{doctorMaxDiagnosisKey}}</span>
                  </div>
                  <div class="number">{{doctorMaxDiagnosisValue}}</div>
                </div>
              </li>
              <li class="item">
                <div class="til">患者最多的医生</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{doctorMaxPatientKey}}</span>
                  </div>
                  <div class="number">{{doctorMaxPatientValue}}</div>
                </div>
              </li>
              <li class="item">
                <div class="til">影像最多的医生</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{doctorMaxImageKey}}</span>
                  </div>
                  <div class="number">{{doctorMaxImageValue}}</div>
                </div>
              </li>
              <li class="item">
                <div class="til">收费最多的医生</div>
                <div class="description">
                  <div class="time">
                    <span class="date">{{doctorMaxFeeKey}}</span>
                  </div>
                  <div class="number">{{doctorMaxFeeValue}}</div>
                </div>
              </li>
            </ul>
          </div>

          <!-- <div class="details-info">
            <div class="head">
              <div class="title">随访数据统计</div>
              <div
                class="period"
                v-show="top10TimeStart && (cycleType === '周' || cycleType === '月' || cycleType === '年')"
              >{{top10TimeStart}} 至 {{top10TimeEnd}}</div>
              <div class="period" v-show="dateStart && cycleType === 'date'">{{dateStart}} 至 {{dateEnd}}</div>
            </div>
            <ul class="line-content">
              <li class="item">
                <div class="til">随访患者状态</div>
                <div class="line-info" ref="followupPatientByState">
                </div>
              </li>
              <li class="item">
                <div class="til">随访患者分组</div>
                <div class="line-info" ref="followupPatientByGroup">
                </div>
              </li>              
              <li class="item">
                <div class="til">随访结果数量</div>
                <div class="line-info" ref="followupResultByTemplate">
                </div>
              </li>
            </ul>  
          </div> -->

          <div class="disease">
            <div class="head">
              <div class="title">TOP10 病种分布</div>
              <div
                class="period"
                v-show="top10TimeStart && (cycleType === '周' || cycleType === '月' || cycleType === '年')"
              >{{top10TimeStart}} 至 {{top10TimeEnd}}</div>
              <div class="period" v-show="dateStart && cycleType === 'date'">{{dateStart}} 至 {{dateEnd}}</div>
            </div>
            <div class="content">
              <!--<div class="head-time">{{top10TimeStart}} ~ {{top10TimeEnd}}</div>-->
              <div class="columnar" ref="barGraph"></div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <StatisticExport
      ref="statisticExport"
    ></StatisticExport>
  </div>
</template>

<script>
  import echarts from 'echarts';
  import moment from 'moment';
  import gql from 'graphql-tag';
  import axios from 'axios';
  import api from '../api';
  import popMixins from "../utils/popMixins.js";
  import StatisticExport from './StatisticExport.vue';

  export default {
    name: '',
    
    components: {
      StatisticExport,
    },
    
    mixins:[popMixins],
    data() {
      return {
        // 左侧筛选绑定数值
        timeDate:{},
        typeValue: '',
        typeOptions: [{
          value: 1,
          label: '影像诊断'
        }, {
          value: 2,
          label: '美容/治疗'
        }],
        imageTypeValue: '',
        roleValue: '',
        roleOptions: [],
        role: -1,
        
        date: '',
        dateStart: '',
        dateEnd: '',
        cycleType: '周',
        // 记住周期状态
        saveCycleType: '周',
        // team状态
        team: false,
        isActive: {
          周: true,
          月: false,
          年: false,
        },
        // 是否显示Floatation
        isShowDiagnoseFloatation: false,
        isShowPatientFloatation: false,
        isShowImageFloatation: false,
        isShowFeeFloatation: false,
        // 上升下降浮动iconfont控制 up down uniformity
        diagnoseFloatation: 'uniformity',
        patientFloatation: 'uniformity',
        imageFloatation: 'uniformity',
        feeFloatation: 'uniformity',

        // 数据绑定
        diagnosisSum: 0,
        patientSum: 0,
        imageSum: 0,
        feeSum: 0,
        diagnosisNum: 0,
        patientNum: 0,
        imageNum: 0,
        feeNum: 0,
        doctorMaxDiagnosisKey: '',
        doctorMaxDiagnosisValue: 0,
        doctorMaxPatientKey: '',
        doctorMaxPatientValue: 0,
        doctorMaxImageKey: '',
        doctorMaxImageValue: 0,
        doctorMaxFeeKey: '',
        doctorMaxFeeValue: 0,
        dayMaxDiagnosisDate: '',
        dayMaxDiagnosisWeek: '',
        dayMaxDiagnosisValue: 0,
        dayMaxPatientDate: '',
        dayMaxPatientWeek: '',
        dayMaxPatientValue: 0,
        dayMaxImageDate: '',
        dayMaxImageWeek: '',
        dayMaxImageValue: 0,
        dayMaxFeeDate: '',
        dayMaxFeeWeek: '',
        dayMaxFeeValue: 0,
        // 总汇柱状图数据
        overallChart: '',
        overallOption: {
          color: ['#6d7472'],
          tooltip: {
            show: false
          },
          legend: {
            show: false,
            data: ['数量']
          },
          xAxis: [
            {
              type: 'category',
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: "数量",
              type: "bar",
              data: [],
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#000',
                      fontWeight: 'bold',
                    }
                  }
                }
              }
            },
          ],
        },
        // 诊断数量线形图数据
        diagnoseChart: '',
        diagnoseOption: {
          color: ['#e8984d'],
          tooltip: {
            show: false
          },
          grid: {
            x: 50,
            y: 30,
            x2: 30,
            y2: 30,
          },
          legend: {
            show: false,
            data: ['数量']
          },
          xAxis: [
            {
              type: 'category',
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value',
            }
          ],
          dataZoom: [
            {
              type: 'inside',
            },
          ],
          series: [
            {
              data: [],
              name: "数量",
              type: "line",
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: '#4da3c0',
                    width: '3'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#e8984d',
                      fontWeight: 'bold',
                    }
                  },
                }
              },
              symbol: 'emptyCircle',
              symbolSize: 10,
              smooth: true,
            },
          ],
        },
        // 患者数量线形图
        patientChart: '',
        patientOption: {
          color: ['#e8984d'],
          tooltip: {
            show: false
          },
          grid: {
            x: 50,
            y: 30,
            x2: 30,
            y2: 30,
          },
          legend: {
            show: false,
            data: ['数量']
          },
          xAxis: [
            {
              type: 'category',
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value',
            }
          ],
          dataZoom: [
            {
              type: 'inside',
            },
          ],
          series: [
            {
              data: [],
              name: "数量",
              type: "line",
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: '#4da3c0',
                    width: '3'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#e8984d',
                      fontWeight: 'bold',
                    }
                  },
                }
              },
              symbol: 'emptyCircle',
              symbolSize: 10,
              smooth: true,
            },
          ],
        },
        // 影像数量折线图
        imageChart: '',
        imageOption: {
          color: ['#e8984d'],
          tooltip: {
            show: false
          },
          grid: {
            x: 50,
            y: 30,
            x2: 30,
            y2: 30,
          },
          legend: {
            show: false,
            data: ['数量']
          },
          xAxis: [
            {
              type: 'category',
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value',
            }
          ],
          dataZoom: [
            {
              type: 'inside',
            },
          ],
          series: [
            {
              data: [],
              name: "数量",
              type: "line",
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: '#4da3c0',
                    width: '3'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#e8984d',
                      fontWeight: 'bold',
                    }
                  },
                }
              },
              symbol: 'emptyCircle',
              symbolSize: 10,
              smooth: true,
            },
          ],
        },
        // 生成费用数量线形图
        costChart: '',
        costOption: {
          color: ['#e8984d'],
          tooltip: {
            show: false
          },
          grid: {
            x: 70,
            y: 30,
            x2: 30,
            y2: 30,
          },
          legend: {
            show: false,
            data: ['数量']
          },
          xAxis: [
            {
              type: 'category',
              data: []
            }
          ],
          yAxis: [
            {
              type: 'value',
            }
          ],
          dataZoom: [
            {
              type: 'inside',
            },
          ],
          series: [
            {
              data: [],
              name: "数量",
              type: "line",
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: '#4da3c0',
                    width: '3'
                  },
                  label: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#e8984d',
                      fontWeight: 'bold',
                    }
                  },
                }
              },
              symbol: 'emptyCircle',
              symbolSize: 10,
              smooth: true,
            },
          ],
        },
        top10TimeStart: '',
        top10TimeEnd: '',
        week: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
        // 医生列表
        doctorList: [],
        // 团队/组
        teamGroupList: [],
      };
    },
    
    computed: {
      imageTypeOptions() {
        if (this.typeValue !== '') {
          if (this.typeValue === 1) {
            this.imageTypeValue = 0;
            return [
              {
                value: 0,
                label: '全部',
              },
              {
                value: 1,
                label: '大体图/伍德灯',
              },
              {
                value: 3,
                label: '皮肤镜',
              },
              {
                value: 8,
                label: '皮肤CT'
              },
              {
                value: 16,
                label: '皮肤B超'
              },
              {
                value: 32,
                label: '皮肤病理',
              },
            ]
          } else if (this.typeValue === 2) {
            this.imageTypeValue = 1;
            return [
              {
                value: 1,
                label: '大体图/伍德灯',
              }
            ]
          }
        } else {
          this.imageTypeValue = '';
          return [];
        }
      },
    },
    
    methods: {
      handleData() {
        if (this.typeValue !== '' && this.imageTypeValue !== '' && this.roleValue !== '') {
          const timeData = this.computeTime(this.cycleType);
          this.timeDate =  timeData;
          this.request(timeData, this.cycleType);
        }
      },
      // 计算请求时间周期
      computeTime(val) {
        const time = {
          newTime: {
            day_start: '',
            day_end: '',
          },
          oldTime: {
            day_start: '',
            day_end: '',
          },
        };
        if (val === '周') {
          const timeStart = moment().startOf('week').subtract(6, 'days').format('YYYY-M-D');
          const timeEnd = moment().endOf('week').subtract(6, 'days').format('YYYY-M-D');
          time.newTime.day_start = timeStart;
          time.newTime.day_end = timeEnd;
          time.oldTime.day_start = moment().startOf('week').subtract(13, 'days').format('YYYY-M-D');
          time.oldTime.day_end = moment().endOf('week').subtract(13, 'days').format('YYYY-M-D');
          this.top10TimeStart = timeStart;
          this.top10TimeEnd = timeEnd;
        } else if (val === '月') {
          const timeStart = moment().subtract(1, 'months').startOf('month').format('YYYY-M-D');
          const timeEnd = moment().subtract(1, 'months').endOf('month').format('YYYY-M-D');
          time.newTime.day_start = timeStart;
          time.newTime.day_end = timeEnd;
          time.oldTime.day_start = moment().subtract(2, 'months').startOf('month').format('YYYY-M-D');
          time.oldTime.day_end = moment().subtract(2, 'months').endOf('month').format('YYYY-M-D');
          this.top10TimeStart = timeStart;
          this.top10TimeEnd = timeEnd;
        } else if (val === '年') {
          const timeStart = moment().subtract(1, 'years').startOf('year').format('YYYY-M-D');
          const timeEnd = moment().subtract(1, 'years').endOf('year').format('YYYY-M-D');
          time.newTime.day_start = timeStart;
          time.newTime.day_end = moment().subtract(1, 'years').endOf('year').format('YYYY-M-D');
          time.oldTime.day_start = moment().subtract(2, 'years').startOf('year').format('YYYY-M-D');
          time.oldTime.day_end = moment().subtract(2, 'years').endOf('year').format('YYYY-M-D');
          this.top10TimeStart = timeStart;
          this.top10TimeEnd = timeEnd;
        } else if (val === 'date') {
          const timeStart = this.dateStart;
          const timeEnd = this.dateEnd;
          time.newTime.day_start = timeStart;
          time.newTime.day_end = timeEnd;
          time.oldTime.day_start = timeStart;
          time.oldTime.day_end = timeEnd;
          this.top10TimeStart = timeStart;
          this.top10TimeEnd = timeEnd;
        }
        return time;
      },
  
      // 选择类型
      imageTypeValueChange() {
        this.$nextTick(() => {
          this.handleData();
        });
      },
      // 选择周、月、年
      selectCycle(val) {
        const cycleType = this.cycleType;
        if (!this.isActive[val]) {
          this.cycleType = val;
          this.saveCycleType = val;
          this.isActive[val] = true;
          this.isActive[cycleType] = false;
          this.date = '';
          // 请求数据
          this.handleData();
        }
      },
      // 选择日期
      dateChange(val) {
        if (val !== null) {
          this.isActive[this.cycleType] = false;
          this.cycleType = 'date';
          this.dateStart = val[0];
          this.dateEnd = val[1];
          this.handleData();
        } else if (val === null) {
          this.cycleType = this.saveCycleType;
          this.handleData();
        }
      },
      // 请求和处理数据
      async request(time, val) {
        const statisticsType = Number(this.roleValue.split('_')[0]);
        const groupId = Number(this.roleValue.split('_')[1]);
        const doctorId = Number(this.roleValue.split('_')[2]);
        // 请求数据
        const newResponse = await this.$apollo.query({
          query: gql`{
                    statistics{
                        diagnosis_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start:"${time.newTime.day_start}"
                          day_end:"${time.newTime.day_end}"
                          statistics_type:${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                        patient_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start:"${time.newTime.day_start}"
                          day_end:"${time.newTime.day_end}"
                          statistics_type:${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                        image_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start: "${time.newTime.day_start}"
                          day_end: "${time.newTime.day_end}"
                          statistics_type: ${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                        fee_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start:"${time.newTime.day_start}"
                          day_end:"${time.newTime.day_end}"
                          statistics_type:${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                    }
                }`,
          fetchPolicy: "no-cache"
        });
        this.diagnosisSum = newResponse.data.statistics.diagnosis_sum;
        this.patientSum = newResponse.data.statistics.patient_sum;
        this.imageSum = newResponse.data.statistics.image_sum;
        this.feeSum = newResponse.data.statistics.fee_sum / 100;
        // 快速浏览 旧数据
        const oldResponse = await this.$apollo.query({
          query: gql`{
                    statistics{
                        diagnosis_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start:"${time.oldTime.day_start}"
                          day_end:"${time.oldTime.day_end}"
                          statistics_type:${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                        patient_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start:"${time.oldTime.day_start}"
                          day_end:"${time.oldTime.day_end}"
                          statistics_type:${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                        image_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start: "${time.oldTime.day_start}"
                          day_end: "${time.oldTime.day_end}"
                          statistics_type: ${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                        fee_sum(
                          type: ${this.typeValue}
                          image_type: ${this.imageTypeValue}
                          day_start:"${time.oldTime.day_start}"
                          day_end:"${time.oldTime.day_end}"
                          statistics_type:${statisticsType}
                          group_id: ${groupId}
                          doctor_id: ${doctorId}
                        )
                    }
                }`,
          fetchPolicy: "no-cache"
        });
        // 计算Floatation
        let newDiagnosis = newResponse.data.statistics.diagnosis_sum;
        let oldDiagnosis = oldResponse.data.statistics.diagnosis_sum;
        let newPatient = newResponse.data.statistics.patient_sum;
        let oldPatient = oldResponse.data.statistics.patient_sum;
        let newImage = newResponse.data.statistics.image_sum;
        let oldImage = oldResponse.data.statistics.image_sum;
        let newFee = newResponse.data.statistics.fee_sum / 100;
        let oldFee = oldResponse.data.statistics.fee_sum / 100;
        // 计算Diagnosis
        if (oldDiagnosis === 0) {
          this.isShowDiagnoseFloatation = false;
        } else {
          const diagnosisFloatation = (((newDiagnosis - oldDiagnosis) / oldDiagnosis) * 100).toFixed(2);
          if (Number(diagnosisFloatation) > 0) {
            this.isShowDiagnoseFloatation = true;
            this.diagnoseFloatation = 'up';
            this.diagnosisNum = diagnosisFloatation;
          } else if (Number(diagnosisFloatation) < 0) {
            this.isShowDiagnoseFloatation = true;
            this.diagnoseFloatation = 'down';
            this.diagnosisNum = diagnosisFloatation.split('-')[1];
          } else if (Number(diagnosisFloatation) === 0) {
            this.isShowDiagnoseFloatation = true;
            if (val === 'date') {
              this.isShowDiagnoseFloatation = false;
            }
            this.diagnoseFloatation = 'uniformity';
            this.diagnosisNum = 0;
          }
        }
        // 计算Patient
        if (oldPatient === 0) {
          this.isShowPatientFloatation = false;
        } else {
          const patientFloatation = (((newPatient - oldPatient) / oldPatient) * 100).toFixed(2);
          if (Number(patientFloatation) > 0) {
            this.isShowPatientFloatation = true;
            this.patientFloatation = 'up';
            this.patientNum = patientFloatation;
          } else if (Number(patientFloatation) < 0) {
            this.isShowPatientFloatation = true;
            this.patientFloatation = 'down';
            this.patientNum = patientFloatation.split('-')[1];
          } else if (Number(patientFloatation) === 0) {
            this.isShowPatientFloatation = true;
            if (val === 'date') {
              this.isShowPatientFloatation = false;
            }
            this.patientFloatation = 'uniformity';
            this.patientNum = 0;
          }
        }
        // 计算Image
        if (oldImage === 0) {
          this.isShowImageFloatation = false;
        } else {
          const imageFloatation = (((newImage - oldImage) / oldImage) * 100).toFixed(2);
          if (Number(imageFloatation) > 0) {
            this.isShowImageFloatation = true;
            this.imageFloatation = 'up';
            this.imageNum = imageFloatation;
          } else if (Number(imageFloatation) < 0) {
            this.isShowImageFloatation = true;
            this.imageFloatation = 'down';
            this.imageNum = imageFloatation.split('-')[1];
          } else if (Number(imageFloatation) === 0) {
            this.isShowImageFloatation = true;
            if (val === 'date') {
              this.isShowImageFloatation = false;
            }
            this.imageFloatation = 'uniformity';
            this.imageNum = 0;
          }
        }
        // 计算Fee
        if (oldFee === 0) {
          this.isShowFeeFloatation = false;
        } else {
          const feeFloatation = (((newFee - oldFee) / oldFee) * 100).toFixed(2);
          if (Number(feeFloatation) > 0) {
            this.isShowFeeFloatation = true;
            this.feeFloatation = 'up';
            this.feeNum = feeFloatation;
          } else if (Number(feeFloatation) < 0) {
            this.isShowFeeFloatation = true;
            this.feeFloatation = 'down';
            this.feeNum = feeFloatation.split('-')[1];
          } else if (Number(feeFloatation) === 0) {
            this.isShowFeeFloatation = true;
            if (val === 'date') {
              this.isShowFeeFloatation = false;
            }
            this.feeFloatation = 'uniformity';
            this.feeNum = 0;
          }
        }
        // 个人请求时控制是否返回按月算的数据
        let isByMonth = false;
        if (statisticsType === 3 && val === '年') {
          isByMonth = true;
        }
        // 如果是请求团队数据
        if (statisticsType === 1 || statisticsType === 2) {
          const response = await this.$apollo.query({
            query: gql`{
                        statistics{
                            doctor_max_diagnosis(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                            ){
                              k
                              v
                            }
                            doctor_max_patient(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                            ){
                              k
                              v
                            }
                            doctor_max_image(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start: "${time.newTime.day_start}",
                              day_end: "${time.newTime.day_end}",
                              statistics_type: ${statisticsType},
                              group_id: ${groupId}
                            ){
                              k
                              v
                            }
                            doctor_max_fee(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                            ){
                                k
                                v
                            }
                            top10_disease_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                            ){
                              k
                              v
                            }
                            diagnosis_count_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                            ){
                              k
                              v
                            }
                            patient_count_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                            ){
                              k
                              v
                            }
                            image_count_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start: "${time.newTime.day_start}",
                              day_end: "${time.newTime.day_end}",
                              statistics_type: ${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                            ){
                              k
                              v
                            }
                            fee_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                            ){
                              k
                              v
                            }
                        }
                    }`,
            fetchPolicy: "no-cache"
          });
          const data = response.data.statistics;
          if (data.doctor_max_diagnosis) {
            this.doctorMaxDiagnosisKey = data.doctor_max_diagnosis.k;
            this.doctorMaxDiagnosisValue = data.doctor_max_diagnosis.v;
          } else {
            this.doctorMaxDiagnosisKey = '';
            this.doctorMaxDiagnosisValue = 0;
          }
          if (data.doctor_max_patient) {
            this.doctorMaxPatientKey = data.doctor_max_patient.k;
            this.doctorMaxPatientValue = data.doctor_max_patient.v;
          } else {
            this.doctorMaxPatientKey = '';
            this.doctorMaxPatientValue = 0;
          }
          if (data.doctor_max_image) {
            this.doctorMaxImageKey = data.doctor_max_image.k;
            this.doctorMaxImageValue = data.doctor_max_image.v;
          } else {
            this.doctorMaxImageKey = '';
            this.doctorMaxImageValue = 0;
          }
          if (data.doctor_max_fee) {
            this.doctorMaxFeeKey = data.doctor_max_fee.k;
            this.doctorMaxFeeValue = data.doctor_max_fee.v / 100;
          } else {
            this.doctorMaxFeeKey = '';
            this.doctorMaxFeeValue = 0;
          }
          this.showEcharts(data, statisticsType === 1 || statisticsType === 2, isByMonth);
        } else {
          const response = await this.$apollo.query({
            query: gql`{
                        statistics{
                            day_max_diagnosis(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}"
                              day_end:"${time.newTime.day_end}"
                              doctor_id: ${doctorId}
                            ){
                                k
                                v
                            }
                            day_max_patient(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}"
                              day_end:"${time.newTime.day_end}"
                              doctor_id: ${doctorId}
                            ){
                                k
                                v
                            }
                            day_max_image(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start: "${time.newTime.day_start}"
                              day_end: "${time.newTime.day_end}"
                              doctor_id: ${doctorId}
                            ){
                                k
                                v
                            }
                            day_max_fee(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}"
                              day_end:"${time.newTime.day_end}"
                              doctor_id: ${doctorId}
                            ){
                                k
                                v
                            }
                            top10_disease_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                            ){
                                k
                                v
                            }
                            diagnosis_count_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                              group_by_month:${isByMonth}
                            ){
                                k
                                v
                            }
                            patient_count_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                              group_by_month:${isByMonth}
                            ){
                                k
                                v
                            }
                            image_count_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start: "${time.newTime.day_start}",
                              day_end: "${time.newTime.day_end}",
                              statistics_type: ${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                              group_by_month: ${isByMonth}
                            ){
                                k
                                v
                            }
                            fee_distribution(
                              type: ${this.typeValue}
                              image_type: ${this.imageTypeValue}
                              day_start:"${time.newTime.day_start}",
                              day_end:"${time.newTime.day_end}",
                              statistics_type:${statisticsType},
                              group_id: ${groupId}
                              doctor_id: ${doctorId}
                              group_by_month:${isByMonth}
                            ){
                                k
                                v
                            }
                        }
                    }`,
            fetchPolicy: "no-cache"
          });
          const data = response.data.statistics;
          const week = this.week;
          if (data.day_max_diagnosis) {
            this.dayMaxDiagnosisDate = moment(data.day_max_diagnosis.k).format('YYYY/M/D');
            this.dayMaxDiagnosisWeek = week[moment(data.day_max_diagnosis.k).day()];
            this.dayMaxDiagnosisValue = data.day_max_diagnosis.v;
          } else {
            this.dayMaxDiagnosisDate = '';
            this.dayMaxDiagnosisWeek = '';
            this.dayMaxDiagnosisValue = 0;
          }
          if (data.day_max_patient) {
            this.dayMaxPatientDate = moment(data.day_max_patient.k).format('YYYY/M/D');
            this.dayMaxPatientWeek = week[moment(data.day_max_patient.k).day()];
            this.dayMaxPatientValue = data.day_max_patient.v;
          } else {
            this.dayMaxPatientDate = '';
            this.dayMaxPatientWeek = '';
            this.dayMaxPatientValue = 0;
          }
          if (data.day_max_image) {
            this.dayMaxImageDate = moment(data.day_max_image.k).format('YYYY/M/D');
            this.dayMaxImageWeek = week[moment(data.day_max_image.k).day()];
            this.dayMaxImageValue = data.day_max_image.v;
          } else {
            this.dayMaxImageDate = '';
            this.dayMaxImageWeek = '';
            this.dayMaxImageValue = 0;
          }
          if (data.day_max_fee) {
            this.dayMaxFeeDate = moment(data.day_max_fee.k).format('YYYY/M/D');
            this.dayMaxFeeWeek = week[moment(data.day_max_fee.k).day()];
            this.dayMaxFeeValue = data.day_max_fee.v / 100;
          } else {
            this.dayMaxFeeDate = '';
            this.dayMaxFeeWeek = '';
            this.dayMaxFeeValue = 0;
          }
          this.showEcharts(data, statisticsType === 1 || statisticsType === 2, isByMonth);
        }
      },
      // 生成echarts图
      async showEcharts(data, team, by) {
        // 生成诊断数量线形图
        if (data.diagnosis_count_distribution.length !== 0) {
          const diagnosisX = [];
          const diagnosisY = [];
          data.diagnosis_count_distribution.forEach(item => {
            if (team) {
              diagnosisX.push(item.k);
            } else {
              if (by) {
                diagnosisX.push(item.k + '月');
              } else {
                diagnosisX.push(moment(item.k).format('M/D'));
              }
            }
            diagnosisY.push(item.v);
          });
          this.diagnoseOption.xAxis[0].data = diagnosisX;
          this.diagnoseOption.series[0].data = diagnosisY;
          this.diagnoseChart.setOption(this.diagnoseOption);
        } else {
          this.diagnoseOption.xAxis[0].data = [];
          this.diagnoseOption.series[0].data = [];
          this.diagnoseChart.setOption(this.diagnoseOption);
        }
        // 生成患者数量线形图
        if (data.patient_count_distribution.length !== 0) {
          const patientX = [];
          const patientY = [];
          data.patient_count_distribution.forEach(item => {
            if (team) {
              patientX.push(item.k);
            } else {
              if (by) {
                patientX.push(item.k + '月');
              } else {
                patientX.push(moment(item.k).format('M/D'));
              }
            }
            patientY.push(item.v);
          });
          this.patientOption.xAxis[0].data = patientX;
          this.patientOption.series[0].data = patientY;
          this.patientChart.setOption(this.patientOption);
        } else {
          this.patientOption.xAxis[0].data = [];
          this.patientOption.series[0].data = [];
          this.patientChart.setOption(this.patientOption);
        }
        // 生成影像数量线形图
        if (data.image_count_distribution.length !== 0) {
          const imageX = [];
          const imageY = [];
          data.image_count_distribution.forEach(item => {
            if (team) {
              imageX.push(item.k);
            } else {
              if (by) {
                imageX.push(item.k + '月');
              } else {
                imageX.push(moment(item.k).format('M/D'));
              }
            }
            imageY.push(item.v);
          });
          this.imageOption.xAxis[0].data = imageX;
          this.imageOption.series[0].data = imageY;
          this.imageChart.setOption(this.imageOption);
        } else {
          this.imageOption.xAxis[0].data = [];
          this.imageOption.series[0].data = [];
          this.imageChart.setOption(this.imageOption);
        }
        // 生成费用数量线形图
        if (data.fee_distribution.length !== 0) {
          const feeX = [];
          const feeY = [];
          data.fee_distribution.forEach(item => {
            if (team) {
              feeX.push(item.k);
            } else {
              if (by) {
                feeX.push(item.k + '月');
              } else {
                feeX.push(moment(item.k).format('M/D'));
              }
            }
            feeY.push(item.v / 100);
          });
          this.costOption.xAxis[0].data = feeX;
          this.costOption.series[0].data = feeY;
          this.costChart.setOption(this.costOption);
        } else {
          this.costOption.xAxis[0].data = [];
          this.costOption.series[0].data = [];
          this.costChart.setOption(this.costOption);
        }
        // 生成总汇柱状图
        if (data.top10_disease_distribution.length !== 0) {
          const top10X = [];
          const top10Y = [];
          // 请求皮肤病名文件
          const response = await axios.request({
            method: 'get',
            url: api.knowledgeDic,
          });
          const obj = response.data;
          data.top10_disease_distribution.forEach(item => {
            if (obj[item.k]) {
              top10X.push(obj[item.k].name);
              top10Y.push(item.v);
            } else{
             if(item.k){
               top10X.push(item.k);
               top10Y.push(item.v);
             }else{
               top10X.push('/');
               top10Y.push(item.v);
             }
           }
          });
          this.overallOption.xAxis[0].data = top10X;
          this.overallOption.series[0].data = top10Y;
          this.overallChart.setOption(this.overallOption);
        } else {
          this.overallOption.xAxis[0].data = [];
          this.overallOption.series[0].data = [];
          this.overallChart.setOption(this.overallOption);
        }
      },
      
      async getGroupList(id) {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              getGroupByDoctorId(doctor_id: ${id}){
                id
                group_name
              }
            }`,
            fetchPolicy: 'no-cache',
          });
          return res.data.getGroupByDoctorId;
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
          return [];
        }
      },
      // 显示导出弹框
      showStatisticExportDialog() {
        this.$refs.statisticExport.showStatisticExportDialog(this.teamGroupList, this.doctorList, this.role,this.timeDate,this.typeValue,this.imageTypeValue );
      },
    },
    async mounted() {
      // 查看是否为普通用户
      const response = await this.$apollo.query({
        query: gql`{
                me{
                    id
                    role
                    doctormember_info{
                      id
                      username
                    }
                    team_info{
                      id
                      team_name
                    }
                }
            }`,
        fetchPolicy: "no-cache"
      });
      this.role = response.data.me.role;
      if (this.role === 1) {  // 如果是团队负责人
        this.typeValue = 1;
        this.imageTypeValue = 0;
        const roleOptions = [{
          value: '1_-1_-1',
          label: '团队',
        }];
        // 请求组
        const groupList = await this.getGroupList(response.data.me.id);
        const doctorList = response.data.me.doctormember_info;
        for (const item of groupList) {
          item.value = '2_' + item.id + '_-1';
          item.label = item.group_name;
          roleOptions.push(item);
        }
        for (const item of doctorList) {
          item.value = '3_-1_' + item.id;
          item.label = item.username;
          roleOptions.push(item);
        }
        this.roleOptions = roleOptions;
        this.roleValue = roleOptions[0].value;
        this.teamGroupList = groupList; // 导出弹框内的团队/组数组数据
        this.teamGroupList.unshift({
          id: response.data.me.team_info[0].id,
          team_name: response.data.me.team_info[0].team_name,
          label: '全部团队',
        });
      } else if (this.role === 2) {  // 如果是组负责人
        this.typeValue = 1;
        this.imageTypeValue = 0;
        const roleOptions = [];
        const groupList = await this.getGroupList(response.data.me.id);
        const doctorList = response.data.me.doctormember_info;
        for (const item of groupList) {
          item.value = '2_' + item.id + '_-1';
          item.label = item.group_name;
          roleOptions.push(item);
        }
        for (const item of doctorList) {
          item.value = '3_-1_' + item.id;
          item.label = item.username;
          roleOptions.push(item);
        }
        this.roleOptions = roleOptions;
        this.roleValue = roleOptions[0].value;
        this.teamGroupList = groupList; // 导出弹框内的团队/组数组数据
      } else if (this.role === 3) {  // 如果是成员
        this.typeValue = 1;
        this.imageTypeValue = 0;
        const roleOptions = response.data.me.doctormember_info;
        for (const item of roleOptions) {
          item.label = item.username;
          item.value = '3_-1_' + item.id;
        }
        this.roleOptions = roleOptions;
        this.roleValue = roleOptions[0].value;
      }
      this.doctorList = response.data.me.doctormember_info; // 导出弹框内的用户数组数据
      
      // 诊断数量线形图
      this.diagnoseChart = echarts.init(this.$refs.diagnoseChart);
      // 患者数量线形图
      this.patientChart = echarts.init(this.$refs.patientChart);
      // 影像数量线形图
      this.imageChart = echarts.init(this.$refs.imagesChart);
      // 费用数量线形图
      this.costChart = echarts.init(this.$refs.costChart);
      // 总汇柱状图
      this.overallChart = echarts.init(this.$refs.barGraph);
  
      // 请求数据
      this.handleData();
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/style/style.less';
  /*改变滚动条样式*/
  /*::-webkit-scrollbar {*/
    /*width: 5px;*/
    /*height: 100%;*/
  /*}*/
  
  /*::-webkit-scrollbar-track-piece {*/
    /*background: #fff;*/
    /*-webkit-border-radius: 6px;*/
  /*}*/
  
  /*::-webkit-scrollbar-thumb:vertical {*/
    /*background-color: #61a2bf;*/
    /*-webkit-border-radius: 6px;*/
  /*}*/


  .info-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 50px;
    bottom: 0;
    margin: 0 auto;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 10px 6%;

      .header-right {
        display: flex;
        align-items: center;

        .calendar.active {
          border: 2px solid @sColor;
        }

        .date--btn-box {
          display: flex;
          height: 30px;
          border: 1px solid #e2e2e2;
          border-radius: 5px;
          overflow: hidden;

          .date-btn {
            width: 80px;
            height: 30px;
            color: @fontColor;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            cursor: pointer;
          }

          .date-btn + .date-btn {
            border-left: 1px solid @bdColor;
          }

          .date-btn.active {
            color: #fff;
            background-color: @sColor;
          }
        }
      }

      .header-left {
        display: flex;
        align-items: center;
        .select-input{
        
        }
        .select-input + .select-input{
          margin-left: 10px;
        }
        
        .export-btn{
          width: 110px;
          height: 16px;
          margin-left: 10px;
          font-size: 14px;
        }

        /*.team-btn {
          width: 80px;
          height: 30px;
          color: @fontColor;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          cursor: pointer;
        }

        .team-btn + .team-btn {
          border-left: 1px solid @bdColor;
        }

        .team-btn.active {
          color: #fff;
          background-color: @sColor;
        }*/
      }
    }

    .wrapper {
      padding: 0px 30px;
      background-color: #ebebeb;

      .head {
        display: flex;

        .title {
          height: 30px;
          color: @sColor;
          margin-right: 20px;
          font-weight: bolder;
          line-height: 30px;
        }

        .period {
          color: #fff;
          padding: 8px 40px;
          border-radius: 10px;
          background-color: @sColor;
          font-size: 14px;
        }
      }

      .quick-view {
        margin-top: 10px;

        .content {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;

          .item {
            position: relative;
            overflow: hidden;
            display: flex;
            justify-content: flex-end;
            /*width: 32.5%;*/
            flex: 1;
            height: 80px;
            border-radius: 10px;
            background-color: #fff;
            border: 1px solid #cdcdcd;

            .left-content {
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              padding: 15px 20px;
              /*background-color: rgba(0,0,0,.3);*/

              .til {
                font-size: 12px;
                font-weight: bolder;
              }

              .info-box {
                display: flex;
                margin-top: 10px;

                .numbers {
                  color: @fontColor;
                  font-size: 26px;
                  font-weight: bolder;
                }

                .floating {
                  display: flex;
                  align-items: center;
                  margin-left: 15px;
                  font-size: 12px;
                  font-weight: bolder;

                  .floating-icon {

                  }

                  .floating-icon.icon-up {
                    color: @sColor;
                  }

                  .floating-icon.icon-down {
                    color: #b31a10;
                  }

                  .floating-num {
                    margin-left: 5px;
                  }
                }
              }
            }

            .icon {
              color: #ececec;
            }

            .icon-1 {
              width: 130px;
              height: 80px;
              font-size: 160px;
              line-height: 128px;
            }

            .icon-2 {
              width: 140px;
              height: 80px;
              font-size: 128px;
              line-height: 108px;
            }

            .icon-3 {
              width: 120px;
              height: 80px;
              font-size: 116px;
              line-height: 120px;
            }
            
            .icon-4{
              width: 93px;
              height: 80px;
              font-size: 116px;
              line-height: 118px;
            }
          }
          .item + .item{
            margin-left: 15px;
          }
        }
      }

      .details-info {
        margin-top: 20px;

        .line-content {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;

          .item {
            overflow: hidden;
            /*width: 32.5%;*/
            flex: 1;
            height: 180px;
            border-radius: 10px;
            background-color: #fff;
            border: 1px solid #cdcdcd;

            .til {
              padding: 15px 20px 0;
              font-size: 12px;
              font-weight: bolder;
            }

            .line-info {
              height: 153px;
            }
          }
          .item + .item{
            margin-left: 15px;
          }
        }

        .max-info {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;

          .item {
            overflow: hidden;
            /*width: 32.5%;*/
            flex: 1;
            height: 66px;
            border-radius: 10px;
            background-color: #fff;
            border: 1px solid #cdcdcd;

            .til {
              padding: 15px 20px 0;
              font-size: 12px;
              font-weight: bolder;
            }

            .description {
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              padding: 0 20px;
              margin-top: 10px;

              .time {
                display: flex;
                align-items: flex-end;
                color: @fontColor;

                .date {
                  font-weight: bold;
                  font-size: 20px;
                }

                .week {
                  margin-left: 5px;
                  padding-bottom: 2px;
                  font-size: 14px;
                }
              }

              .number {
                color: #000;
                font-size: 20px;
                font-weight: bold;
              }
            }
          }
          .item + .item{
            margin-left: 15px;
          }
        }
      }

      .disease {
        margin-top: 20px;

        .content {
          position: relative;
          overflow: hidden;
          height: 280px;
          border-radius: 10px;
          background-color: #fff;
          border: 1px solid #cdcdcd;
          margin-top: 15px;

          .head-time {
            position: absolute;
            overflow: hidden;
            top: 15px;
            right: 30px;
            color: @fontColor;
          }

          .columnar {
            height: 100%;
          }
        }
      }
    }
  }
</style>
